var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarOutlineWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.429 2.08603L10.7521 2.40902L11.429 2.08603C10.8554 0.884085 9.14456 0.884084 8.57102 2.08603L6.63775 6.13751C6.6256 6.16297 6.60139 6.18055 6.57343 6.18424L2.12283 6.77091C0.802476 6.94496 0.273783 8.57211 1.23967 9.489L4.49544 12.5796C4.5159 12.599 4.52514 12.6275 4.52001 12.6552L3.70266 17.0693C3.46017 18.3788 4.84431 19.3844 6.0148 18.7492L9.96025 16.6078C9.98504 16.5943 10.015 16.5943 10.0398 16.6078L13.9852 18.7492C15.1557 19.3844 16.5398 18.3788 16.2973 17.0693L15.48 12.6552C15.4749 12.6275 15.4841 12.599 15.5046 12.5796L18.7603 9.489C19.7262 8.57211 19.1975 6.94496 17.8772 6.77091L13.4266 6.18424C13.3986 6.18055 13.3744 6.16297 13.3623 6.13751L11.429 2.08603Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutlineWhite);
export default __webpack_public_path__ + "static/media/star-outline-white.7891eb7bcea8ff880d4c669a01b20c16.svg";
export { ForwardRef as ReactComponent };